import { ATTRIBUTE } from './attributes';

export const EVENT_TYPE = {
    EOCR_MATCH_REQUEST: 62,
    CONTAINER_DETECTION: 69,
    EDGE_OCR_DETECT: 71,
    EDGE_RAILROAD_DETECTION: 179,
    EDGE_RAILROAD_EXIT: 180,
    EDGE_RAILCAR_DETECTION: 181,
    RAIL_IN: 183,
    RAIL_OUT: 184
}

export const EVENT_ATTR = {
    LIEA_TIMESTAMP: ATTRIBUTE.LIEA_TIMESTAMP,
    CAMERA_TIMESTAMP: ATTRIBUTE.CAMERA_TIMESTAMP
}